import React, { useState, useEffect } from "react";
import { useReactFlow } from "@xyflow/react";
import { updateFlow } from "@/services/common";
import { Button, Space } from "antd";
import { AppProvider, useAppContext } from "@/AppContext";
import userInfo from "@/Components/user";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import CusBreadcrumb from "@/Pages/Project/Flow/Right/CusBreadcrumb";
import { getQueryString } from "@/config/func";
// 新建流程
const pageType1 = [
  {
    label: "全局设置",
    key: "settingMaterial",
    route: "/project/:k/flow/:f/setting", // 补充路由模板
  },
  {
    label: "流程设计",
    key: "simulation",
    route: "/project/:k/flow/:f/design1", // 补充路由模板
  },
];

// 查看流程、编辑流程：
const pageType2 = [
  {
    label: "全局设置",
    key: "settingMaterial",
    route: "/project/:k/flow/:f/setting", // 全局设置路由模板
  },
  {
    label: "流程设计",
    key: "simulation",
    route: "/project/:k/flow/:f/design1", // 流程设计路由模板
  },
  {
    label: "计算任务管理",
    key: "results",
    route: "/project/:k/flow/:f/task", // 计算任务管理路由模板
  },
];

const Component = (props: any) => {
  const history = useNavigate();
  const curl: any = useLocation();
  // ========== 修改点4：获取路由参数（k和f） ==========
  const params = useParams(); // 从路由中获取:k和:f参数
  const projectId = params.k || getQueryString('k'); // 优先从路由参数取，兼容查询参数
  const flowId = params.f || getQueryString('f');
  // ========== 修改点4结束 ==========
  const { state, actions } = useAppContext();

  const {
    curTitle,
    curPage,
    curProject,
    curFlow,
    projectList,
    flowMode,
    refreshMenu,
    curJob,
    curResultPage,
    viewSettingPage,
  } = state;
  const {
    setCurTitle,
    setCurPage,
    setCurFlow,
    setProjectList,
    setCurProject,
    setRefreshMenu,
    setCurResultPage,
    setViewSettingPage,
  } = actions;
  // console.log("curFlow", curFlow);
  const [isEditTitle, setIsEditTitle] = useState<any>(false);
  const { fitView } = useReactFlow();
  // ========== 关键修改2：监听路由变化，同步更新curPage状态（可选但推荐） ==========
  useEffect(() => {
    // 根据当前路由匹配对应的page项
    const getCurrentPageItem = () => {
      const allPages = [...pageType1, ...pageType2];
      const currentPath = location.pathname;

      // 遍历所有页面配置，匹配当前路由
      return allPages.find(item => {
        if (!item.route) return false;
        // 替换路由模板中的参数，生成实际路由
        const actualRoute = item.route
          .replace(":k", params.k || getQueryString('k'))
          .replace(":f", params.f || getQueryString('f'));
        return currentPath === actualRoute;
      });
    };

    const currentPageItem = getCurrentPageItem();
    if (currentPageItem && curPage?.key !== currentPageItem.key) {
      setCurPage(currentPageItem); // 同步更新curPage状态
    }
  }, [location.pathname, params, curPage]); // 监听路由和参数变化
  // ========== 关键修改2结束 ==========


  useEffect(() => {
    if (curPage.key === "simulation") {
      setTimeout(() => {
        fitView();
      }, 100);
    }
  }, [curPage]);

  const r_tabs: any = ["计算结果", "计算参数"];
  const settingPage_tabs: any = ["流程图", "单元操作", "流股"];

  const changeTitle = () => {
    const i: any = document.getElementById("flowTitle");

    updateFlow(
      curProject.id,
      curFlow.id,
      {
        name: i.value,
      },
      userInfo.access_token
    ).then((r) => {
      if (r.status === 200) {
        setIsEditTitle(false);
        setCurFlow({
          ...curFlow,
          name: i.value,
        });
        let p: any = [];
        projectList.map((item: any) => {
          let o: any = {
            ...item,
          };
          if (item.flows.length) {
            const fls: any = [];
            item.flows.map((fl: any) => {
              let t: any = {
                ...fl,
                name:
                  item.id === curProject.id && fl.id === curFlow.id
                    ? i.value
                    : fl.name,
              };
              fls.push(t);
            });
            o = {
              ...o,
              flows: fls,
            };
          }
          p.push(o);
        });
        setProjectList(p);
        setCurTitle(i.value);
        setRefreshMenu(!refreshMenu);
      }
    });
  };

  //绑定快捷键提交更新flow name
  const keySubUpdateTitle = (e: any) => {
    if (e.key === "Enter") {
      changeTitle();
    }
    if (e.key === "Escape") {
      setIsEditTitle(false);
    }
  };

  const content = (pageType: any) => {
    return (
      <li className="step-container">
        {pageType.map((item: any, index: any) => {
          const actualRoute = item.route
            ? item.route.replace(":k", projectId).replace(":f", flowId)
            : "";
          // 判断当前是否是激活状态（路由匹配）
          const isCurrent = actualRoute && curl.pathname === actualRoute;
          // ========== 修改点5结束 ==========
          return (
            <>
              <div
                key={item.key}
                className={isCurrent ? "step active" : "step notActive"}
                // ========== 修改点6：点击事件改为路由跳转 ==========
                onClick={() => {
                  if (actualRoute) {
                    history(actualRoute); // 路由跳转
                  } else {
                    setCurPage(item); // 兼容原有逻辑（pageType1）
                  }
                }}
              // ========== 修改点6结束 ==========
              >
                <div
                  className={
                    isCurrent // ========== 修改点7：激活状态判断改为路由匹配 ==========
                      ? "step-number active"
                      : "step-number notActive"
                  }
                >
                  {index + 1}
                </div>
                <div className="step-label">{item.label}</div>
              </div>

              {index !== pageType.length - 1 && (
                <div className="step-arrow">→</div>
              )}
            </>
          );
        })}
      </li>
    );
  };

  // ========== 修改点8：重构taskManage函数为路由跳转 ==========
  const taskManage = (item: any) => {
    // 生成实际路由
    const actualRoute = item.route
      ? item.route.replace(":k", projectId).replace(":f", flowId)
      : "";
    if (actualRoute) {
      if (item.key === "results") {
        const s: any = curl.search.split("&");
        history(`${actualRoute}${s.length ? `?${s.join('&')}` : ''}`); // 保留查询参数
      } else {
        history(actualRoute);
      }
    }
    // 可选：保留curPage状态同步（如果其他地方依赖）
    setCurPage(item);
  };

  const showViewFlowTop = () => {
    // getQueryString("j"),
    if (flowMode === "查看流程") {
      if (getQueryString("j")) {
        // setCurPage('计算结果')
        if (curJob?.status === "done") {
          //有计算结果
          return (
            <>
              {r_tabs.map((item: any, index: any) => {
                return (
                  <li
                    key={index}
                    className={curResultPage === item ? "active" : ""}
                    onClick={() => setCurResultPage(item)}
                    style={{ border: "1px solid rgba(0,0,0,0.1)" }}
                  >
                    {item}
                  </li>
                );
              })}
            </>
          );
        } else {
          return (
            <>
              {settingPage_tabs.map((item: any, index: any) => {
                return (
                  <li
                    key={index}
                    className={viewSettingPage === item ? "active" : ""}
                    onClick={() => setViewSettingPage(item)}
                    style={{ border: "1px solid rgba(0,0,0,0.1)" }}
                  >
                    {item}
                  </li>
                );
              })}
            </>
          );
        }
      } else {
        return pageType2.map((item, index) => {
          // 判断当前是否是激活状态（路由匹配）
          const actualRoute = item.route
            ? item.route.replace(":k", projectId).replace(":f", flowId)
            : "";
          const isCurrent = actualRoute && curl.pathname === actualRoute;
          return (
            <li
              key={item.key}
              className={isCurrent ? "active" : "notActive"}
              onClick={() => {
                taskManage(item);
              }}
            >
              {item.label}
            </li>
          );
        });
      }
    }
  };

  return (
    <div className="ss_left">
      <ul className="ss_selector">
        <li>
          <CusBreadcrumb
            isEditTitle={isEditTitle}
            setIsEditTitle={setIsEditTitle}
          />
        </li>
        {flowMode === "新建流程" && content(pageType1)}
        {flowMode === "编辑流程" && content(pageType2)}
        {showViewFlowTop()}
        {/* <Button
          size="small"
          style={{ border: "none" }}
          onClick={() => {
            const projectId = getQueryString('k');
            const flowId = getQueryString('f');
            history(`/project/${projectId}/flow/${flowId}/design`);
          }}
        >
          流程设计测试按钮
        </Button> */}
        {/* {flowMode === "查看流程" &&
          pageType2.map((item) => (
            <li
              key={item.key}
              className={curPage.key === item.key ? "active" : "notActive"}
              onClick={() => {
                taskManage(item);
              }}
            >
              {item.label}
            </li>
          ))} */}
      </ul>
    </div>
  );
};

export default Component;
